export default __webpack_public_path__ + "static/media/cloud-sql.92b2d6c2.svg";